// standards-ignore: co-located-test — pure constant + type-only module (i18n
// bundle id and key union), no logic to test.

/** i18n bundle + typed key union shared by SubQuestionsStep and SubQuestionRow. */
export const SUB_QUESTIONS_BUNDLE = 'features.audit-whiz.translations.reviewQuestions';

export type SubKey =
  | 'subStepHeading'
  | 'subSectionHeading'
  | 'subSectionInfo'
  | 'subInfoAltText'
  | 'subAddButton'
  | 'subRowLabel'
  | 'subUntitledLabel'
  | 'subDeleteAltText'
  | 'subEmptyText'
  | 'subTitleLabel'
  | 'subTitlePlaceholder'
  | 'subInstructionLabel'
  | 'subInstructionPlaceholder'
  | 'subCommentOnFailLabel'
  | 'subEvidenceOnFailLabel'
  | 'subCommentOnPassLabel'
  | 'subEvidenceOnPassLabel'
  | 'subTaskHeading'
  | 'subAddTaskButton'
  | 'subRemoveTaskButton'
  | 'criteriaTaskNameLabel'
  | 'criteriaTaskNamePlaceholder'
  | 'criteriaTaskDescriptionLabel'
  | 'criteriaTaskDescriptionPlaceholder'
  | 'criteriaTaskDurationLabel'
  | 'criteriaTaskDurationPlaceholder';
